import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { gateway } from 'src/environments/gateway';

@Injectable({
  providedIn: 'root',
})
export class RegisterService {
  serverBaseUrl = gateway.apiUrl;

  constructor(private http: HttpClient) {}

  registerUser(credentials: any): Observable<any> {
    return this.http.post(`${this.serverBaseUrl}/api/auth/signup`, credentials);
  }
}
